import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
  UiModuleOverviewConfiguration,
  DisplayFieldConfiguration,
  SeahorseModule,
} from '@seahorse/domain';
import {
  ShButtonComponent,
  ShFieldComponent,
  ShInputComponent,
} from '@seahorse/components';
import { DialogService, ShTableComponent } from '@seahorse/shell';
import type { ShColumn } from '@seahorse/shell';
import { SeahorseModuleOverviewConfigurationDialogComponent } from '../seahorse-module-overview-configuration-dialog/seahorse-module-overview-configuration-dialog.component';

@Component({
  selector: 'su-seahorse-module-overview-configuration-card',
  templateUrl: './seahorse-module-overview-configuration-card.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    ShButtonComponent,
    ShFieldComponent,
    ShInputComponent,
    ShTableComponent,
  ],
})
export class SeahorseModuleOverviewConfigurationCardComponent
  implements OnInit
{
  @Input() seahorseModule: SeahorseModule;
  @Input() overviewConfiguration: UiModuleOverviewConfiguration | null = null;

  // Stable fields: they feed sh-table.
  displayFieldRows: DisplayFieldConfiguration[] = [];
  readonly columns: ShColumn<DisplayFieldConfiguration>[] = [
    { key: 'field', header: 'reports.customdata.fieldName' },
    {
      key: 'columnName',
      header: 'uiModules.columnName',
      value: (row) => row.columnName || row.name,
    },
    {
      key: 'subDisplayFields',
      header: 'uiModules.subDisplayFields',
      value: (row) => row.subDisplayFields || '',
    },
    {
      key: 'sortField',
      header: 'uiModules.sortOrder',
      value: (row) => row.sortField ?? '',
    },
  ];

  private readonly _dialogService = inject(DialogService);

  ngOnInit(): void {
    this.refreshRows();
  }

  /** The stored sort order is a boolean or, saved by the old form, "true" / "false". */
  get isSortAscending(): boolean {
    return String(this.overviewConfiguration?.sortOrder) === 'true';
  }

  private refreshRows(): void {
    this.displayFieldRows = (
      this.overviewConfiguration?.displayFieldsConfiguration || []
    ).map((f) => ({ ...f }));
  }

  openDialog(): void {
    this._dialogService
      .open(SeahorseModuleOverviewConfigurationDialogComponent, {
        title: 'uiModules.overview.configuration',
        width: 'lg',
        data: {
          seahorseModule: this.seahorseModule,
          configuration: this.overviewConfiguration,
        },
      })
      .afterOk.subscribe((result) => {
        this.overviewConfiguration = result;
        this.refreshRows();
      });
  }
}
